import AdminConfig from './admin.vue'
import ClientView from './client.vue'

export default {
  name: 'timeline',
  type: 'module',
  label: 'Timeline',
  components: { admin: AdminConfig, client: ClientView },
  settings: { icon: 'mdi-timeline-clock-outline' },
}
